import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);

  params.Codigo && (path = `${path !== '' ? `${path}&` : ''}Codigo=${params.Codigo}`);
  params.Descripcion &&
    (path = `${path !== '' ? `${path}&` : ''}Descripcion=${params.Descripcion}`);
  params.Ingreso && (path = `${path !== '' ? `${path}&` : ''}Ingreso=${params.Ingreso}`);
  params.Egreso && (path = `${path !== '' ? `${path}&` : ''}Egreso=${params.Egreso}`);
  params.Transferencia &&
    (path = `${path !== '' ? `${path}&` : ''}Transferencia=${params.Transferencia}`);
  params.Autonumerico &&
    (path = `${path !== '' ? `${path}&` : ''}Autonumerico=${params.Autonumerico}`);
  params.ProximoNumero &&
    (path = `${path !== '' ? `${path}&` : ''}ProximoNumero=${params.ProximoNumero}`);
  params.Prefijo && (path = `${path !== '' ? `${path}&` : ''}Prefijo=${params.Prefijo}`);
  params.Activo && (path = `${path !== '' ? `${path}&` : ''}Activo=${params.Activo}`);

  return path;
};
